import { Text } from '@pukka/ui-components';

const TNC_URL = 'https://www.mokapos.com/syarat-dan-ketentuan#digitalpayment';

const HEPLDESK_URL = 'https://help.mokapos.com/s/?language=in';

function QRISGoPayIntroText() {
  return (
    <div className="flex-1">
      <Text variant="subtitle-2" weight="semibold" className="p-4">
        Accepting QRIS Payment with Ease
      </Text>
      <Text className="px-[18px] py-4 text-neutral-700" variant="subtitle-1">
        Start accepting payments with QRIS Payment at your outlets, allow your customers to make cashless payments from any digital payment
        providers.
        <br />
        <br />
        By using the QRIS service, you declare that you know and agree to the latest QRIS{' '}
        <Text as="a" href={TNC_URL} target="_blank" className="underline" color="blue" weight="bold">
          Payment Terms and Conditions
        </Text>
        .
        <br />
        <br />
        If you need assistance, please call us on{' '}
        <Text as="a" color="blue" weight="bold" href="tel:1500970">
          1500970
        </Text>{' '}
        or visit the{' '}
        <Text as="a" href={HEPLDESK_URL} target="_blank" className="underline" color="blue" weight="bold">
          Helpdesk
        </Text>{' '}
        for further information.
        <br />
        <br />
        -----------
        <br />
        <br />
        <i>
          Mulai terima pembayaran dengan QRIS di outlet Anda agar pelanggan Anda bisa melakukan pembayaran non-tunai dari layanan pembayaran
          digital apa pun yang mereka miliki.
          <br />
          <br />
          Dengan menggunakan layanan QRIS, Anda menyatakan telah mengetahui dan menyetujui{' '}
        </i>
        <Text as="a" href={TNC_URL} target="_blank" color="blue">
          Syarat dan Ketentuan Pembayaran
        </Text>{' '}
        <i>QRIS terbaru.</i>
        <br />
        <br />
        <i>Jika Anda membutuhkan bantuan, silakan hubungi kami di </i>
        <Text as="a" color="blue" href="tel:1500970">
          1500970
        </Text>{' '}
        <i>atau kunjungi </i>
        <Text as="a" href={HEPLDESK_URL} target="_blank" color="blue">
          Helpdesk
        </Text>{' '}
        <i>untuk informasi lebih lanjut.</i>
      </Text>
    </div>
  );
}

export { QRISGoPayIntroText };
